export const MODULES = ["dashboard", "sales", "projects", "calendar", "shoot_schedule", "team", "show_performance"];

const FULL = Object.fromEntries(MODULES.map((m) => [m, "full"]));

export const MODULE_ACCESS = {
  admin: FULL,
  vice_president: FULL,
  group_head: { dashboard: "view", sales: "view", projects: "full", calendar: "full", shoot_schedule: "full", team: "view", show_performance: "full" },
  associate_group_head: { dashboard: "view", sales: "view", projects: "full", calendar: "full", shoot_schedule: "full", team: "view", show_performance: "full" },
  producer: { dashboard: "view", sales: "none", projects: "full", calendar: "full", shoot_schedule: "full", team: "none", show_performance: "view" },
  production_manager: { dashboard: "view", sales: "none", projects: "view", calendar: "full", shoot_schedule: "full", team: "none", show_performance: "view" },
  editor: { dashboard: "view", sales: "none", projects: "full", calendar: "full", shoot_schedule: "view", team: "none", show_performance: "view" },
  trainee: { dashboard: "view", sales: "none", projects: "full", calendar: "full", shoot_schedule: "view", team: "none", show_performance: "view" },
};

export const AUDIO_ENTRY_ROLES = ["admin", "vice_president", "group_head", "associate_group_head", "producer"];

export const LEADERSHIP_ROLES = ["admin", "vice_president", "group_head", "associate_group_head"];
export function canCreateProject(role) { return LEADERSHIP_ROLES.includes(role); }
export function canEditProjectInfo(role) { return LEADERSHIP_ROLES.includes(role); }

const ORDER = { none: 0, view: 1, full: 2 };

export function accessLevel(role, module) {
  return (MODULE_ACCESS[role] || {})[module] || "none";
}

export function can(role, module, level = "view") {
  return (ORDER[accessLevel(role, module)] || 0) >= (ORDER[level] || 0);
}

export const ROLES = [
  { key: "admin", label: "Admin" },
  { key: "vice_president", label: "Vice President" },
  { key: "group_head", label: "Group Head" },
  { key: "associate_group_head", label: "Associate Group Head" },
  { key: "producer", label: "Producer" },
  { key: "production_manager", label: "Production Manager" },
  { key: "editor", label: "Editor/Designer" },
  { key: "trainee", label: "Trainee" },
];

export const ROLE_LABELS = Object.fromEntries(ROLES.map((r) => [r.key, r.label]));

export const ROLE_COLORS = {
  admin: "bg-[#FF3B30]/10 text-[#FF3B30] border-[#FF3B30]/20",
  vice_president: "bg-[#FF3B30]/10 text-[#FF3B30] border-[#FF3B30]/20",
  group_head: "bg-[#FFCC00]/10 text-[#FFCC00] border-[#FFCC00]/20",
  associate_group_head: "bg-[#FFCC00]/10 text-[#FFCC00] border-[#FFCC00]/20",
  producer: "bg-[#8B5CF6]/10 text-[#8B5CF6] border-[#8B5CF6]/20",
  production_manager: "bg-[#06B6D4]/10 text-[#06B6D4] border-[#06B6D4]/20",
  editor: "bg-[#34C759]/10 text-[#34C759] border-[#34C759]/20",
  trainee: "bg-fg3/10 text-fg2 border-line",
};
